import { Type } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { createFileRoute } from '@tanstack/react-router';
import { useFlagsStatus } from '@unleash/proxy-client-react';

import AuctionsList from '@/components/_auctions/AuctionsList';
import { AuctionLayout } from '@/components/layouts';
import PageLoading from '@/components/loading/PageLoading';
import PageDisabled from '@/components/PageDisabled';
import useFlag from '@/lib/hooks/useFlag';

const AuctionsPage = () => {
  const featuresReady = useFlagsStatus().flagsReady;
  const enableAuctions = useFlag('auctions');

  if (!featuresReady) {
    return <PageLoading />;
  }

  if (!enableAuctions) {
    return <PageDisabled absolutelyCentered />;
  }

  return <AuctionsList />;
};

const AuctionsSearch = Type.Object({
  filter: Type.Optional(Type.Union([Type.Literal('myBids'), Type.Literal('')])),
});

export const Route = createFileRoute('/auctions/')({
  component: () => (
    <AuctionLayout title="shared.navigation.auctions">
      <AuctionsPage />
    </AuctionLayout>
  ),
  validateSearch: (search) => Value.Cast(AuctionsSearch, search),
});
